import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import plugin from './plugins/index'
import './plugins/vant.js'
import './plugins/element.js'
import './assets/css/common.css'
import './assets/font/iconfont.css'
import {_isMobile} from "@/utils/utils";
import { List ,Checkbox } from 'vant';
Vue.use(List);
Vue.use(Checkbox);
if (_isMobile()) {
  import('./assets/css/mobile.css')
} else {
  import('./assets/css/web.css')
}
Vue.config.productionTip = false
Vue.use(plugin)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
